<div class="header-button">
  <button mat-button [matMenuTriggerFor]="Notification" aria-label="mode" class="header-item" [ngStyle]="{color:'white'}">
    <fa-icon [ngStyle]="{color:'white'}" [icon]="faNotification"></fa-icon>
  </button>
  <button mat-button [matMenuTriggerFor]="user" aria-label="mode" class="header-item">
    <a class="pc-head-link">
      <fa-icon [icon]="faUser" [ngStyle]="{color:'white'}" class="fa-lg"></fa-icon>
      <img *ngIf="userProfile?.profile?.attributes!['avatar']" src="{{userProfile?.profile?.attributes!['avatar']}}" alt="user-image" class="user-avatar" />
    </a>
  </button>
  <mat-menu #Notification="matMenu" xPosition="before" class="dropdown-notification">
    <div *ngFor="let item of listaTotale.slice(0,5)">
      <app-list-item [item]="item"></app-list-item>
    </div>
    <div class="dropdown-header flex align-item-center justify-content-between">
      <h5 class="m-b-0"></h5>
  
    </div>
    <ng-scrollbar *ngIf="mainCards.length>0" style="height: calc(100vh - 215px)" visibility="hover">
      <div class="dropdown-body">
       
      </div>
    </ng-scrollbar>
  </mat-menu>
  <mat-menu #user="matMenu" xPosition="before" class="dropdown-user-profile">
 
    <ng-scrollbar style="height: calc(10vh)" visibility="hover">
      <div class="dropdown-body">
        <div class="flex m-b-5">
          <div class="topic-icon">
            <fa-icon [icon]="faUser" class="fa-lg"></fa-icon>
      <img *ngIf="userProfile?.profile?.attributes!['avatar']" src="{{userProfile?.profile?.attributes!['avatar']}}" alt="user-image" class="user-avatar" />    
          </div>
          <div class="topic-description m-l-15">
            <h6 class="user-name">{{userProfile?.profile?.firstName+" "+userProfile?.profile?.lastName}}</h6>
            <p class="mat-body">{{userProfile?.profile?.email}}</p>
          </div>
        </div>
      </div>
    </ng-scrollbar>
  </mat-menu>
</div>
